'use client';
import styled from '@benzinga/themetron';
import React from 'react';
import { InputWrapper } from './InputContainer';
import dynamic from 'next/dynamic';
import type { SingleValue } from 'react-select';

const Select = dynamic(() => import('react-select'), {
  loading: () => <SelectSkeleton />,
  ssr: false,
}) as unknown as typeof import('react-select').default;

interface SelectProps {
  label?: string;
  onChange: (newValue: SingleValue<Option>) => void;
  options: Option[];
  value: Option;
  tooltip?: React.ReactNode;
}

export interface Option {
  value: string;
  label: string;
}

export const SelectContainer: React.FC<SelectProps> = ({ label, onChange, options, tooltip, value }) => {
  const handleChange = React.useCallback(
    (option: SingleValue<Option>) => {
      if (option && option.value) {
        onChange(option);
      }
    },
    [onChange],
  );

  return (
    <SelectWrapper className="select-wrapper">
      <InputWrapper name={label} tooltip={tooltip}>
        <Select onChange={handleChange} options={options} value={value} />
      </InputWrapper>
    </SelectWrapper>
  );
};

export default SelectContainer;

const SelectWrapper = styled.div`
  &.select-wrapper {
  }
`;

const SelectSkeleton = styled.div`
  min-height: 38px;
  border: 1px solid hsl(0, 0%, 80%);
  border-radius: 4px;
  background: #fff;
`;
